export const filters = () => {
  
  const filtersContainer = document.querySelector(".js-filters");

  if (!filtersContainer) {
    return; // Exit the function if the element with class 'js-filters' doesn't exist
  }

  const filtersListDate = document.querySelector('[data-filters-list="date"]');
  const filterItemsDate = filtersListDate.querySelectorAll("[data-filter]");

  const filtersListLocation = document.querySelector(
    '[data-filters-list="location"]'
  );
  const filterItemsLocation = filtersListLocation.querySelectorAll(
    "[data-filter]"
  );

  const filtersListCategory = document.querySelector(
    '[data-filters-list="category"]'
  );
  const filterItemsCategory = filtersListCategory.querySelectorAll(
    "[data-filter]"
  );

  const itemsToFilter = document.querySelectorAll(".js-item-to-filter");

  const activeFilters = {
    date: "",
    location: "",
    category: "",
  };

  const init = () => {
    applyActiveFilters();
    bind();
  };

  const bind = () => {
    filterItemsDate.forEach((item) => {
      item.addEventListener("click", function (evt) {
        evt.preventDefault();
        updateActiveFilter("date", this.getAttribute("data-filter"));
        applyActiveFilters();
      });
    });

    filterItemsLocation.forEach((item) => {
      item.addEventListener("click", function (evt) {
        evt.preventDefault();
        updateActiveFilter("location", this.getAttribute("data-filter"));
        applyActiveFilters();
      });
    });

    filterItemsCategory.forEach((item) => {
      item.addEventListener("click", function (evt) {
        evt.preventDefault();
        updateActiveFilter("category", this.getAttribute("data-filter"));
        applyActiveFilters();
      });
    });
  };

  const updateActiveFilter = (filterType, filterValue) => {
    activeFilters[filterType] = filterValue;
  };

  const applyActiveFilters = () => {

          let visibleItemsCount = 0; // Track the count of visible items

          filterItemsDate.forEach((item) => {
            const filterValue = activeFilters.date;
            if (item.getAttribute("data-filter") === filterValue) {
              item.classList.add("is-current");
            } else {
              item.classList.remove("is-current");
            }
          });

          filterItemsLocation.forEach((item) => {
            const filterValue = activeFilters.location;
            if (item.getAttribute("data-filter") === filterValue) {
              item.classList.add("is-current");
            } else {
              item.classList.remove("is-current");
            }
          });

          filterItemsCategory.forEach((item) => {
            const filterValue = activeFilters.category;
            if (item.getAttribute("data-filter") === filterValue) {
              item.classList.add("is-current");
            } else {
              item.classList.remove("is-current");
            }
          });

          itemsToFilter.forEach((item) => {
            const dateFilter = activeFilters.date || "";
            const locationFilter = activeFilters.location || "";
            const categoryFilter = activeFilters.category || "";

            const itemDate = item.getAttribute("data-event-date");
            const itemLocation = item.getAttribute("data-event-location");
            const itemCategory = item.getAttribute("data-event-category");

            if (
              itemDate.includes(dateFilter) &&
              itemLocation.includes(locationFilter) &&
              itemCategory.includes(categoryFilter)
            ) {
              item.classList.remove("is-hidden");
              visibleItemsCount++; // Increment count for visible items
            } else {
              item.classList.add("is-hidden");
            }

            // Show empty state if all items are hidden
            if (visibleItemsCount === 0) {
              // Code to show the empty state element if no visible item exists
              const elementToShow = document.querySelector(".js-element-empty-state");
              if (elementToShow) {
                elementToShow.classList.remove("is-hidden");
              }
            } else {
              // Code to hide the element if any visible item exists
              const elementToShow = document.querySelector(".js-element-empty-state");
              if (elementToShow) {
                elementToShow.classList.add("is-hidden");
              }
            }
                      
          });
        };;

  // Initialize the filters if a filter list exists
  if (filtersListCategory) {
    init();
  }
};
